import axios, { InternalAxiosRequestConfig } from "axios";

import serviceRequest from "api/serviceRequest";
import publicConfig from "config/public";
import serverConfig from "config/server";

import { apiOgErrorInterceptor } from "./api-og";
// Initialize the service request with the app and environment
const apiOgInternal = serviceRequest();

// Configure and set upstream URL
apiOgInternal.defaults.baseURL = publicConfig.services.apiOgInternal.url;

// The OAuth credentials are only available in the server environment
// This is a sensitive operation and should not be exposed to the client
// This check should signal the bundler to exclude this block from the client bundle
if (typeof window === "undefined") {
  const tokenCache = {
    expiry: Date.now(),
    token: "",
  };

  const getOAuthToken = async () => {
    if (tokenCache.token && Date.now() < tokenCache.expiry) {
      return tokenCache.token;
    }

    const clientId = serverConfig.leaflyOauth.clientId;
    const clientSecret = serverConfig.leaflyOauth.clientSecret;
    const tokenUrl = serverConfig.leaflyOauth.tokenUrl;

    try {
      const response = await axios.post(
        tokenUrl,
        new URLSearchParams({
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: "client_credentials",
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      const { access_token, expires_in } = response.data;

      tokenCache.token = access_token;
      const expiresInMs = (expires_in - 30) * 1000;
      tokenCache.expiry = Date.now() + expiresInMs;

      return access_token;
    } catch (error) {
      throw new Error("OAuth token fetch failed");
    }
  };

  const internalAuthInterceptor = async (
    config: InternalAxiosRequestConfig,
  ) => {
    const oauthToken = await getOAuthToken();
    config.headers.set("Authorization", `Bearer ${oauthToken}`);
    return config;
  };

  apiOgInternal.interceptors.response.use(
    (response) => response,
    apiOgErrorInterceptor,
  );

  apiOgInternal.interceptors.request.use(
    internalAuthInterceptor,
    apiOgErrorInterceptor,
  );
}
export default apiOgInternal;
